<div class="customer-info">
  <div class="customer-info-row multiple-controls">
    <div class="form-control">
      <label class="form-label">
        {{ 'customer_info.phone_number' | translate }}
      </label>

      <div class="form-input-container">
        <div
          class="form-input"
          [class.form-input-invalid]="isControlInvalid('phoneNumber')"
          [class.disabled]="!!customerService.customer2().contactInfo.phoneNumber"
          (click)="onPhoneNumberInputClick()"
        >
          {{ customerService.customer2().contactInfo.phoneNumber | mask:PHONE_NUMBER_MASK }}
        </div>

        @if (customerService.customer2().contactInfo.phoneNumber && !customerService.customer2().contactInfo.isPhoneNumberConfirmed) {
          <button
            class="form-control-button"
            type="button"
            (click)="onConfirmPhoneNumber()"
            [matTooltip]="'customer_info.confirm_phone_number' | translate"
            matTooltipPosition="above"
          >
            <tc-icon iconType="check-circle" />
          </button>
        }

        <button
          class="form-control-button"
          type="button"
          (click)="onChangePhoneNumber()"
          [matTooltip]="'customer_info.change_phone_number' | translate"
          matTooltipPosition="above"
        >
          <tc-icon iconType="edit" />
        </button>
      </div>

      @if (isControlInvalid('phoneNumber')) {
        <div class="form-control-error">
          {{ 'global.required_field' | translate }}
        </div>
      }
    </div>

    <div class="form-control">
      <label class="form-label">
        {{ 'global.email' | translate }}
      </label>

      <div class="form-input-container">
        <div
          class="form-input"
          [class.form-input-invalid]="isControlInvalid('email')"
          [class.disabled]="!!customerService.customer2().contactInfo.email"
          (click)="onEmailInputClick()"
        >
          {{ customerService.customer2().contactInfo.email }}
        </div>

        @if (customerService.customer2().contactInfo.email && !customerService.customer2().contactInfo.isEmailConfirmed) {
          <button
            class="form-control-button"
            type="button"
            (click)="onConfirmEmail()"
            [matTooltip]="'customer_info.confirm_email' | translate"
            matTooltipPosition="above"
          >
            <tc-icon iconType="check-circle" />
          </button>
        }

        <button
          class="form-control-button"
          type="button"
          (click)="onChangeEmail()"
          [matTooltip]="'customer_info.change_email' | translate"
          matTooltipPosition="above"
        >
          <tc-icon iconType="edit" />
        </button>
      </div>

      @if (isControlInvalid('email')) {
        <div class="form-control-error">
          {{ 'global.required_field' | translate }}
        </div>
      }
    </div>
  </div>

  <div class="customer-info-row">
    <div class="form-control">
      <label class="form-label">
        {{ 'customer_info.full_name' | translate }}
      </label>

      <div class="form-input-container">
        <div
          class="form-input"
          [class.form-input-invalid]="isControlInvalid('name')"
          [class.disabled]="!!customerService.customer2().contactInfo.lastName && !!customerService.customer2().contactInfo.firstName"
          (click)="onNameInputClick()"
        >
          {{ customerService.customer2().contactInfo.lastName + ' ' + customerService.customer2().contactInfo.firstName + ' ' + customerService.customer2().contactInfo.middleName }}
        </div>

        <button
          class="form-control-button"
          type="button"
          (click)="onChangeName()"
          [matTooltip]="'customer_info.change_name' | translate"
          matTooltipPosition="above"
        >
          <tc-icon iconType="edit" />
        </button>
      </div>

      @if (isControlInvalid('name')) {
        <div class="form-control-error">
          {{ 'global.required_field' | translate }}
        </div>
      }
    </div>
  </div>
</div>
